import { api } from './api';

export type GenAction = 'generate' | 'refine' | 'suggest';

export interface GenerationLimits {
  defaults: Record<GenAction, number | null>;
  overrides: Array<{ cardId: string; action: GenAction; maxPerReport: number | null }>;
}

export interface GenerationCount {
  cardId: string;
  action: GenAction;
  count: number;
  limit: number | null;
}

export const generationLimitsApi = {
  list: () => api.get<GenerationLimits>('/api/admin/generation-limits'),
  setDefault: (action: GenAction, maxPerReport: number | null) =>
    api.put<{ ok: boolean }>(`/api/admin/generation-limits/default/${action}`, { maxPerReport }),
  setCardOverride: (cardId: string, action: GenAction, maxPerReport: number | null) =>
    api.put<{ ok: boolean }>(`/api/admin/generation-limits/card/${encodeURIComponent(cardId)}/${action}`, { maxPerReport }),
  resetCardOverride: (cardId: string, action: GenAction) =>
    api.delete<{ ok: boolean }>(`/api/admin/generation-limits/card/${encodeURIComponent(cardId)}/${action}`),
  getCountsForReport: (reportId: number) =>
    api.get<{ items: GenerationCount[] }>(`/api/reports/${reportId}/generation-counts`),
};
